export default __webpack_public_path__ + "static/media/uploader-ascensiaContour-problem-2.c5135b42.png";